<template>
  <!-- begin:: Header Topbar -->
  <div class="topbar">
    <b-dropdown
      size="sm"
      variant="link"
      toggle-class="topbar-item text-decoration-none"
      no-caret
      left
      no-flip
    >
      <!-- v-slot:button-content -->
      <template v-slot:button-content>
        <div
          class="btn btn-icon btn-clean btn-dropdown btn-lg mr-1 pulse pulse-success"
          @click="$router.push({ path: '/beds/list' })"
        >
          <span
            class="svg-icon svg-icon-xl svg-icon-primary"
            v-b-tooltip.hover
            style="fill: #a12260"
            title="Jumlah bangsal tersedia"
            :class="`svg-icon-info`"
          >
            <inline-svg src="/media/svg/icons/Home/Bed.svg" />
          </span>
          <span class="pulse-ring"></span>
          <span
            v-if="available_bed > 0"
            class="label label-sm label-light-danger text-danger label-rounded font-weight-bolder position-absolute top-0 right-0 mt-1 mr-1"
          >
            {{ available_bed }}
          </span>
        </div>
      </template>
      <!-- <b-dropdown-text tag="div" class="min-w-md-350px">
        <form>
          <KTDropdownNotification
            :available_bed="available_bed"
          ></KTDropdownNotification>
        </form>
      </b-dropdown-text> -->
    </b-dropdown>

    <b-dropdown
      size="sm"
      variant="link"
      toggle-class="topbar-item text-decoration-none"
      no-caret
      left
      no-flip
    >
      <template v-slot:button-content>
        <div
          class="btn btn-icon btn-clean btn-dropdown btn-lg mr-1 pulse pulse-info"
          @click="goToPayment"
        >
          <span
            class="svg-icon svg-icon-xl svg-icon-primary"
            v-b-tooltip.hover
            title="Pembayaran terdaftar hari ini"
            :class="`svg-icon-info`"
          >
            <inline-svg src="/media/svg/icons/Shopping/Credit-card.svg" />
          </span>
          <span class="pulse-ring"></span>
          <span
            v-if="invoice_today > 0"
            class="label label-sm label-light-danger text-danger label-rounded font-weight-bolder position-absolute top-0 right-0 mt-1 mr-1"
          >
            {{ invoice_today }}
          </span>
        </div>
      </template>
      <!-- <b-dropdown-text tag="div" class="min-w-md-350px">
        <form>
          <WMPaymentNotification
            :invoice_today="invoice_today"
          ></WMPaymentNotification>
        </form>
      </b-dropdown-text> -->
    </b-dropdown>

    <b-dropdown
      size="sm"
      variant="link"
      toggle-class="topbar-item text-decoration-none"
      no-caret
      left
      no-flip
    >
      <template v-slot:button-content>
        <div
          class="btn btn-icon btn-clean btn-dropdown btn-lg mr-1 pulse pulse-info"
          @click="$router.push({ path: '/patient/list' })"
        >
          <span
            class="svg-icon svg-icon-xl svg-icon-primary"
            v-b-tooltip.hover
            title="Pasien terdaftar hari ini"
            :class="`svg-icon-info`"
          >
            <inline-svg src="/media/svg/icons/Communication/Group.svg" />
          </span>
          <span class="pulse-ring"></span>
          <span
            v-if="new_patients > 0"
            class="label label-sm label-light-danger text-danger label-rounded font-weight-bolder position-absolute top-0 right-0 mt-1 mr-1"
          >
            {{ new_patients }}
          </span>
        </div>
      </template>
      <!-- <b-dropdown-text tag="div" class="min-w-md-350px">
        <form>
          <WMPatientNotification
            :new_patients="new_patients"
          ></WMPatientNotification>
        </form>
      </b-dropdown-text> -->
    </b-dropdown>

    <b-dropdown
      size="sm"
      variant="link"
      toggle-class="topbar-item text-decoration-none"
      no-caret
      left
      no-flip
    >
      <template v-slot:button-content>
        <div
          class="btn btn-icon btn-clean btn-dropdown btn-lg mr-1 pulse pulse-success"
          @click="$router.push({ path: '/schedule/list' })"
        >
          <span class="svg-icon svg-icon-xl svg-icon-primary" v-b-tooltip.hover
            title="Dokter bertugas hari ini" :class="`svg-icon-info`">
            <!-- <inline-svg src="/media/svg/icons/Communication/Contact1.svg" /> -->
            <inline-svg src="/media/svg/icons/General/User.svg" />
          </span>
          <span class="pulse-ring"></span>
          <span
            v-if="doctor_available > 0"
            class="label label-sm label-light-danger text-danger label-rounded font-weight-bolder position-absolute top-0 right-0 mt-1 mr-1"
          >
            {{doctor_available}}
          </span>
        </div>
      </template>
      <!-- <b-dropdown-text tag="div" class="min-w-md-350px">
        <form>
          <WMDonorNotification></WMDonorNotification>
        </form>
      </b-dropdown-text> -->
    </b-dropdown>

    <b-dropdown
      size="sm"
      variant="link"
      toggle-class="topbar-item text-decoration-none"
      no-caret
      left
      no-flip
    >
      <template v-slot:button-content>
        <div
          class="btn btn-icon btn-clean btn-dropdown btn-lg mr-1 pulse pulse-success"
          @click="$router.push({ path: '/appointment/todays' })"
        >
          <span
            class="svg-icon svg-icon-xl svg-icon-primary"
            v-b-tooltip.hover
            title="Perjanjian terdaftar hari ini"
            :class="`svg-icon-info`"
          >
            <inline-svg src="/media/svg/icons/Communication/Clipboard-check.svg" />
          </span>
          <span class="pulse-ring"></span>
          <span
            v-if="new_appointments > 0"
            class="label label-sm label-light-danger text-danger label-rounded font-weight-bolder position-absolute top-0 right-0 mt-1 mr-1"
          >
            {{ new_appointments }}
          </span>
        </div>
      </template>
      <!-- <b-dropdown-text tag="div" class="min-w-md-350px">
        <form>
          <WMMedicineNotification
            :new_appointments="new_appointments"
          ></WMMedicineNotification>
        </form>
      </b-dropdown-text> -->
    </b-dropdown>

    <b-dropdown
      size="sm"
      variant="link"
      toggle-class="topbar-item text-decoration-none"
      no-caret
      left
      no-flip
    >
      <template v-slot:button-content>
        <div
          class="btn btn-icon btn-clean btn-dropdown btn-lg mr-1 pulse pulse-success"
          @click="$router.push({ path: '/appointment/list/1' })"
        >
          <span
            class="svg-icon svg-icon-xl svg-icon-primary"
            v-b-tooltip.hover
            title="Perjanjian yang baru diajukan"
            :class="`svg-icon-info`"
          >
            <inline-svg
              src="/media/svg/icons/Communication/Clipboard-list.svg"
            />
          </span>
          <span class="pulse-ring"></span>
          <span
            v-if="appointment_submission > 0"
            class="label label-sm label-light-danger text-danger label-rounded font-weight-bolder position-absolute top-0 right-0 mt-1 mr-1"
          >
            {{ appointment_submission }}
          </span>
        </div>
      </template>
      <!-- <b-dropdown-text tag="div" class="min-w-md-350px">
        <form>
          <WMReportNotification
            :appointment_submission="appointment_submission"
          ></WMReportNotification>
        </form>
      </b-dropdown-text> -->
    </b-dropdown>

    <b-dropdown
      size="sm"
      variant="link"
      toggle-class="topbar-item text-decoration-none"
      no-caret
      left
      no-flip
    >
      <template v-slot:button-content>
        <div
          class="btn btn-icon btn-clean btn-dropdown btn-lg mr-1 pulse pulse-success"
          @click="$router.push({ path: '/medicine/expiration-warning' })"
        >
          <span
            class="svg-icon svg-icon-xl svg-icon-primary"
            v-b-tooltip.hover
            title="Obat Kedaluwarsa"
            :class="`svg-icon-info`"
          >
            <inline-svg
              src="/media/svg/icons/Code/Time-schedule.svg"
            />
          </span>
          <span class="pulse-ring"></span>
          <span
            v-if="total_medicine_expired > 0"
            class="label label-sm label-light-danger text-danger label-rounded font-weight-bolder position-absolute top-0 right-0 mt-1 mr-1"
          >
            {{total_medicine_expired}}
          </span>
        </div>
      </template>
    </b-dropdown>

    <!--begin: User Bar -->
    <KTQuickUser></KTQuickUser>
    <!--end: User Bar -->
  </div>
  <!-- end:: Header Topbar -->
</template>

<style lang="scss">
.topbar {
  .dropdown-toggle {
    padding: 0;
    &:hover {
      text-decoration: none;
    }

    &.dropdown-toggle-no-caret {
      &:after {
        content: none;
      }
    }
  }

  .dropdown-menu {
    margin: 0;
    padding: 0;
    outline: none;
    .b-dropdown-text {
      padding: 0;
    }
  }
}
</style>

<style scoped>
.text-custom{
  color: #993366 !important;
}
</style>

<script>
import KTQuickUser from "@/view/layout/extras/offcanvas/QuickUser.vue";
import i18nService from "@/core/services/i18n.service.js";
import KTDropdownNotification from "@/view/layout/extras/dropdown/DropdownNotification.vue";
import WMPaymentNotification from "@/view/layout/extras/dropdown/PaymentNotification.vue";
import WMPatientNotification from "@/view/layout/extras/dropdown/PatientNotification.vue";
import WMDonorNotification from "@/view/layout/extras/dropdown/DonorNotification.vue";
import WMMedicineNotification from "@/view/layout/extras/dropdown/MedicineNotification.vue";
import WMReportNotification from "@/view/layout/extras/dropdown/ReportNotification.vue";
import module from '@/core/modules/CrudModule.js'
import ApiService from "@/core/services/api.service.js";

export default {
  name: "KTTopbar",
  data() {
    return {
      languageFlag: "",
      languages: i18nService.languages,
      available_bed: null,
      invoice_today: null,
      new_patients: null,
      new_appointments: null,
      appointment_submission: null,
      doctor_available: null,
      total_medicine_expired: null,
      today: new Date().toISOString().substr(0, 10),
      events: [],
      colors: [
        "blue",
        "indigo",
        "deep-purple",
        "cyan",
        "green",
        "orange",
        "grey darken-1",
      ],
    };
  },
  components: {
    KTQuickUser,
    KTDropdownNotification,
    WMPaymentNotification,
    WMPatientNotification,
    WMDonorNotification,
    WMMedicineNotification,
    WMReportNotification,    
  },
  methods: {
    onLanguageChanged() {
      this.languageFlag = this.languages.find((val) => {
        return val.lang === i18nService.getActiveLanguage();
      }).flag;
    },
    getTotalMedicineExpired() {
      ApiService.get("total-medicine-expireds").then((response) => {
        this.total_medicine_expired = response.data;
      });
    },
    getAvailableBed() {
      ApiService.get("total-available-beds").then((response) => {
        this.available_bed = response.data;
      });
    },
    getAppointmentToday() {
      ApiService.get("total-appointments-today").then((response) => {
        this.new_appointments = response.data;
      });
    },
    getNewPayment() {
      ApiService.get("total-new-payments").then((response) => {
        this.invoice_today = response.data;
        // JwtService.setNewInvoice(response.data)
      });
    },
    updateNewPayment() {
      ApiService.get("total-new-payments").then((response) => {
        this.invoice_today = response.data;
        // JwtService.setNewInvoice(response.data)
      });
    },
    getNewPatient() {
      ApiService.get("total-new-patients").then((response) => {
        this.new_patients = response.data;
      });
    },
    getAppointmentSubmission() {
      ApiService.get("total-submission").then((response) => {
        this.appointment_submission = response.data;
      });
    },

    // Set doctor Today
    getEventColor(event) {
      return event.color;
    },

    random(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a;
    },

    async getAppointment() {
      return await module.list(`schedules/get-calendar?doctor_id=`);
    },

    async getEvents() {
      let arr = [],
        date = this.getMonday(new Date());
      for (let i = 1; i <= 8; i++) {
        i == 1
          ? arr.push(new Date(date.setDate(date.getDate())))
          : arr.push(new Date(date.setDate(date.getDate() + 1)));
      }
      const events = [];
      const schedules = await this.getAppointment();
      let start, end;
      for (let i = 0; i < schedules.length; i++) {
        for (let j = 0; j < arr.length; j++) {
          if (
            schedules[i].day_name ==
            new Date(arr[j]).toLocaleString("id-ID", { weekday: "long" })
          ) {
            start = new Date(arr[j]);
            start.setHours(schedules[i].start_hour);
            start.setMinutes(schedules[i].start_minute);
            end = new Date(arr[j]);
            end.setHours(schedules[i].end_hour);
            end.setMinutes(schedules[i].end_minute);
            events.push({
              name: schedules[i].name,
              weekdays: 1,
              start: start,
              end: end,
              color: this.colors[this.random(0, this.colors.length - 1)],
              timed: true,
            });
          }
        }
      }
      this.events = events;

      let doctorToday = [];
      let a;
      for (a = 0; a < this.events.length; a++) {
        if (
          this.events[a].start.toISOString().substr(0, 10) ==
          new Date().toISOString().substr(0, 10)
        ) {
          doctorToday.push(this.events[a].name);
        }
        this.doctor_available = doctorToday.length
      }
    },

    getMonday(d) {
      d = new Date(d);
      var day = d.getDay(),
        diff = d.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
      return new Date(d.setDate(diff));
    },

    goToAppointment(){
      this.$root.$emit('appointment-submission', 'semoga jalan');
      this.$router.push({ path: '/appointment/list' })
    },

    goToPayment(){
      window.localStorage.setItem("list_today", "1")
      this.$router.push({ path: '/payment/list' })
    }    
  },
  mounted() {
    this.getTotalMedicineExpired();
    this.getAvailableBed();
    this.getAppointmentToday();
    this.getNewPayment();
    this.getNewPatient();
    this.getAppointmentSubmission();
    this.getEvents();

    this.$root.$on("UpdateNewPayment", (text) => {
      console.log(text);
      this.getNewPayment();
    });
    this.$root.$on("UpdateNewAvailableBed", () => {
      this.getAvailableBed();
    });
    this.$root.$on("UpdateNewPatient", () => {
      this.getNewPatient();
    });
    this.$root.$on("UpdateNewAppointment", () => {
      this.getAppointmentToday();
      this.getAppointmentSubmission();
    });
    this.$root.$on("UpdateAvailableDoctor", () => {
      this.getEvents()
    });
  },  
  computed: {
    getLanguageFlag() {
      return this.onLanguageChanged();
    },
    newInvoice() {
      return window.localStorage.getItem("new_invoice");
    },    
  },
};
</script>
